<template>
  <v-card 
    class="agency-card elevation-8 mt-2"
    :class="{ 'hovered': isHovered }"
    @mouseenter="isHovered = true"
    @mouseleave="isHovered = false"
  >
    <!-- Background with gradient overlay -->
    <div class="bg-container">
      <v-img
        :src="agency.bgImage || require('@/assets/background0.png')"
        width="100%"
        :aspect-ratio="$vuetify.breakpoint.smAndDown ? 414 / 180 : 1654 / 455"
        class="bg-image"
      >
        <div class="gradient-overlay"></div>
        <div class="glass-overlay"></div>
      </v-img>
    </div>

    <!-- Main content -->
    <div class="content-wrapper">
      <!-- Avatar with premium styling -->
      <div class="avatar-container" :class="{ 'floating': isHovered }">
        <div class="avatar-ring"></div>
        <div class="avatar-wrapper" @click="goToProfile">
          <agency-avatar
            v-if="agency.midThumbnail"
            :img="agency.midThumbnail || agency.image"
            :name="agency.name"
            class="avatar-img"
          />

        <img
            v-else
            :src="placeholderImage"
            alt="Profile_Default"
            class="avatar-img"
          />
          <div class="avatar-overlay">
            <v-icon color="white" size="20">mdi-eye</v-icon>
          </div>
        </div>
      </div>

      <!-- Name and location -->
      <div class="profile-info">
        <h2 
          class="profile-name"
          @click="goToProfile"
          v-if="agency.name"
        >
          {{ truncateName(agency.name) }}
          <v-icon class="verified-badge" color="#1DA1F2" size="18" v-if="agency.email_verified">
            mdi-check-decagram
          </v-icon>
        </h2>
             <div class="location-wrapper">
        <div class="location-info" v-if="agency.address">
          <v-icon class="location-icon">mdi-map-marker</v-icon>
          <span class="location-text">
            <!-- {{ agency.address2 ? `, ${agency.address2}: "" }} -->
            {{ agency.address }} , {{ agency.city }}
          </span>
        </div>
             </div>
      </div>

      <!-- Stats section with modern cards -->
      <div class="stats-container">
        <div class="stat-card hours-card" @click="goToFollowers">
          <div class="stat-icon-wrapper hours">
            <v-icon class="stat-icon">mdi mdi-account-multiple-plus-outline</v-icon>
          </div>
          <div class="stat-content">
            <div class="stat-number">
              {{ (agency.followed_by?.length || 0) - (agency.followed_by?.includes(agency._id) ? 1 : 0) }}
            </div>
            <div class="stat-label">
              {{
                ((agency.followed_by?.length || 0) - (agency.followed_by?.includes(agency._id) ? 1 : 0)) === 1
                ? 'Follower'
                : 'Followers'
              }}
            </div>
          </div>
          <div class="stat-hover-effect"></div>
        </div>

        <div class="divider-line"></div>

        <div class="stat-card followers-card" @click="goToFollowings">
          <div class="stat-icon-wrapper followers">
            <v-icon class="stat-icon">mdi-account-group</v-icon>
          </div>
          <div class="stat-content">
            <div class="stat-number">
              {{ (agency.followers?.length || 0) - (agency.followers?.includes(agency._id) ? 1 : 0) }}
            </div>
            <div class="stat-label">Following</div>
          </div>
          <div class="stat-hover-effect"></div>
        </div>
      </div>

   
    </div>
  </v-card>
</template>

<script>
import AgencyAvatar from "./AgencyAvatar.vue";

export default {
  components: { AgencyAvatar },
  props: {
    agency: Object,
    onClicked: Function
  },
  data() {
    return {
      isHovered: false,
      placeholderImage: require("@/assets/default.jpg"),
    };
  },
  computed: {
    getCompletedInfo() {
      if (!this.agency._id) return "";
      const missingFields = [];

      const checks = [
        { field: "image", label: "Logo" },
        { field: "who_we_are", label: "Who we are" },
        { field: "what_we_do", label: "What we do" },
        {
          condition: !this.agency.contact_person || !this.agency.contact_title,
          label: "Contact Info"
        },
        { field: "phone", label: "Phone" },
        { field: "address", label: "Address" },
        { field: "city", label: "City" },
        { field: "state", label: "State" },
        { field: "zip", label: "Zip" },
        { condition: !this.agency.phone_verified, label: "Phone verification" },
        { condition: !this.agency.email_verified, label: "Email verification" }
      ];

      checks.forEach(item => {
        if ("field" in item) {
          if (!this.agency[item.field]) missingFields.push(item.label);
        } else if (item.condition) {
          missingFields.push(item.label);
        }
      });

      return missingFields.length > 0;
    }
  },
  methods: {
    goToProfile() {
      this.$router.push({
        name: "agency-profile-details",
        params: { id: this.agency._id }
      });
    },
    goToSetting() {
      if (!this.agency.email_verified || !this.agency.phone_verified) {
        this.$router.push({ name: "settings" });
      } else {
        this.$router.push({
          name: "agency-profile-about",
          params: { id: this.agency._id }
        });
      }
    },
  truncateName(name, length = 15) {
    if (!name) return '';
    return name.length > length ? name.slice(0, length) + '...' : name;
  },
    goToFollowings() {
      this.$router.push({
        name: "agencies",
        query: { tab: "following" } 
      });
    },
    goToFollowers(){
      this.$router.push({
        name: "agencies",
        query: { tab: "followers" } 
      });

    }
  }
};
</script>

<style scoped>
.agency-card {
  position: relative;
  border-radius: 24px !important;
  overflow: hidden;
  /* background: linear-gradient(145deg, #ffffff, #f8f9fa); */
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  backdrop-filter: blur(10px);
  /* border: 1px solid rgba(255, 255, 255, 0.2); */
  max-width: 400px;
  margin: 0 auto;
}

.agency-card.hovered {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15) !important;
}

.bg-container {
  position: relative;
  overflow: hidden;
}

.bg-image {
  border-radius: 24px 24px 0 0;
  transition: transform 0.6s ease;
}

.agency-card.hovered .bg-image {
  transform: scale(1.1);
}

.gradient-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, 
    rgba(8, 68, 104, 0.3) 0%, 
    rgba(10, 91, 138, 0.3) 50%, 
    rgba(10, 91, 138, 0.3) 100%);
}

.glass-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(1px);
}

.content-wrapper {
  padding: 0 24px 24px;
  position: relative;
}

.avatar-container {
  display: flex;
  justify-content: center;
  margin-top: -46px;
  margin-bottom: 14px;
  position: relative;
  z-index: 2;
  transition: transform 0.3s ease;
}

.avatar-container.floating {
  transform: translateY(-4px);
}

/* .avatar-ring {
  position: absolute;
  width: 104px;
  height: 104px;
  border: 3px solid;
  border-image: linear-gradient(45deg, #667eea, #764ba2) 1;
  border-radius: 50%;
  top: -4px;
  left: 50%;
  transform: translateX(-50%);
  animation: rotate 8s linear infinite;
} */

@keyframes rotate {
  from { transform: translateX(-50%) rotate(0deg); }
  to { transform: translateX(-50%) rotate(360deg); }
}

.avatar-wrapper {
  position: relative;
  width: 92px;
  height: 92px;
  border-radius: 50%;
  /* overflow: hidden; */
  cursor: pointer;
  transition: all 0.3s ease;
  /* background: linear-gradient(145deg, #f0f0f0, #cacaca); */
  /* padding: 4px; */
}

.avatar-wrapper:hover {
  transform: scale(1.05);
}

.avatar-img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  transition: all 0.3s ease;
}

.avatar-overlay {
  position: absolute;
    top: 3px;
    left: 3px;
    right: -5px;
    bottom: -5px;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: 50%;
}

.avatar-wrapper:hover .avatar-overlay {
  opacity: 1;
}

.profile-info {
  text-align: center;
  margin-bottom: 10px;
}

.profile-name {
    font-size: 22px;
    font-weight: 600;
    color: #084468;
    margin: 0px 0 2px 0;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.profile-name:hover {
  color: #0a5b8a;
  transform: translateY(-1px);
}

.verified-badge {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
}

.location-info {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: #718096;
  font-size: 14px;
}

.location-icon {
  color: #E52020 !important;
  font-size: 16px !important;
}

.stats-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  gap: 16px;
}

.stat-card {
  border-radius: 16px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.05);
  background: linear-gradient(145deg, #ffffff, #f7fafc);
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
}

.stat-hover-effect {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
  transition: left 0.5s ease;
}

.stat-card:hover .stat-hover-effect {
  left: 100%;
}

.stat-icon-wrapper {
  width: 40px;
  height: 40px;
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
  transition: transform 0.3s ease;
}

.stat-icon-wrapper.hours {
  background: linear-gradient(135deg, #0a5b8a, #1DA1F2);
}

.stat-icon-wrapper.followers {
  background: linear-gradient(135deg, #0a5b8a, #4CAF50);
}

.stat-card:hover .stat-icon-wrapper {
  transform: scale(1.1) rotate(5deg);
}

.stat-icon {
  color: white !important;
  font-size: 20px !important;
}

.stat-content {
  text-align: center;
}

.stat-number {
  font-size: 24px;
  font-weight: 700;
  color: #1a202c;
  line-height: 1;
  margin-bottom: 4px;
}

.stat-label {
  font-size: 12px;
  color: #718096;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.divider-line {
  width: 1px;
  height: 40px;
  background: linear-gradient(to bottom, #00000063, #006dff, transparent);
  margin: 0 8px;
}

.action-buttons {
  display: flex;
  gap: 12px;
}

.action-btn {
  flex: 1;
  height: 48px !important;
  border-radius: 12px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px;
  transition: all 0.3s ease !important;
}

.primary-btn {
  background: linear-gradient(135deg, #084468, #0a5b8a) !important;
  color: white !important;
}

.primary-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(102, 126, 234, 0.4) !important;
}

.secondary-btn {
  border: 2px solid #0a5b8a !important;
  color: #0a5b8a !important;
}

.secondary-btn:hover {
  background: #0a5b8a !important;
  color: white !important;
  transform: translateY(-2px);
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .agency-card {
    margin: 16px;
    border-radius: 20px !important;
  }
  
  .content-wrapper {
    padding: 0 20px 20px;
  }
  
  .profile-name {
    font-size: 20px;
  }
  
  .stat-card {
    padding: 12px;
  }
  
  .stat-number {
    font-size: 20px;
  }
  
  .action-buttons {
    flex-direction: column;
  }
}


.location-wrapper {    display: inline-flex;    align-items: center;    background: rgba(236, 240, 241, 0.7);    padding: 6px 12px;    border-radius: 20px;    transition: all 0.3s ease;}
</style>